module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/login/reset-password/reset-password.component.scss
// module id = ./src/app/login/reset-password/reset-password.component.scss
// module chunks = main